// src/models/atributoModel.js

import pb from '../lib/pocketbase';

// Obtener una lista de atributos con paginación
export async function getAtributos(page, perPage) {
  return await pb.collection('atributo').getList(page, perPage, {
    sort: '-created',
    $autoCancel: false // Desactiva la auto-cancelación
  });
}

// Crear un nuevo atributo
export async function createAtributo(atributo) {
  return await pb.collection('atributo').create(atributo);
}

// Actualizar un atributo existente
export async function updateAtributo(id, atributo) {
  return await pb.collection('atributo').update(id, atributo);
}

// Eliminar un atributo por su ID
export async function deleteAtributo(id) {
  return await pb.collection('atributo').delete(id);
}
